"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableHead = exports.TableCell = exports.TableRow = exports.TableBody = exports.Table = exports.TableContainer = void 0;
const Table_1 = __importDefault(require("@mui/material/Table"));
const TableBody_1 = __importDefault(require("@mui/material/TableBody"));
const TableCell_1 = __importDefault(require("@mui/material/TableCell"));
const TableContainer_1 = __importDefault(require("@mui/material/TableContainer"));
const TableHead_1 = __importDefault(require("@mui/material/TableHead"));
const TableRow_1 = __importDefault(require("@mui/material/TableRow"));
const react_1 = __importDefault(require("react"));
const styles = {
    calendar: {
        '& td': {
            //border: `1px solid ${theme.palette.grey[200]}`,
            border: 1,
            borderColor: 'grey.200',
        },
    },
};
exports.TableContainer = TableContainer_1.default;
const Table = ({ variant = 'default', ...props }) => (
// @ts-ignore
react_1.default.createElement(Table_1.default, { sx: styles[variant], ...props }));
exports.Table = Table;
exports.TableBody = TableBody_1.default;
exports.TableRow = TableRow_1.default;
exports.TableCell = TableCell_1.default;
exports.TableHead = TableHead_1.default;
